// Application configuration
export const config = {
  // API Configuration
  apiUrl: process.env.REACT_APP_API_URL || 'https://bassist.meander.one/api',
  
  // Demo Mode (set to true to force demo mode, even if backend is available)
  demoMode: process.env.REACT_APP_DEMO_MODE === 'true' || true, // Default to true
  
  // Backend Server URL (used for proxy in development)
  backendUrl: process.env.REACT_APP_BACKEND_URL || 'https://bassist.meander.one/api',
  
  // Check if we should use demo mode
  shouldUseDemoMode: () => {
    // Default to demo mode unless explicitly disabled
    return config.demoMode;
  },
  
  // Demo credentials for display
  demoCredentials: [
    { username: 'admin', password: 'admin123', role: 'admin' },
    { username: 'user', password: 'user123', role: 'user' },
    { username: 'manager', password: 'manager123', role: 'manager' },
  ],
};
